import gql from 'graphql-tag';
import { apolloClient as apollo } from '@/vue-apollo';

export const getJobBackgroundList = async (params = null) => {
  let variables = {
    status: null,
    limit: 10,
    offset: 0
  };

  if (params) {
    variables = {
      ...variables,
      ...params
    };
  }

  const query = gql`
    query GetJobBackgroundList($status: Int, $limit: Int, $offset: Int) {
      GetJobBackgroundList(Status: $status, Limit: $limit, Offset: $offset) {
        id
        createdAt
        updatedAt
        taskType
        status
        expenseIdList
        projectId
      }
    }
  `;
  const {
    data: { GetJobBackgroundList }
  } = await apollo.query({
    query,
    variables,
    fetchPolicy: 'no-cache'
  });

  return GetJobBackgroundList;
};
